import React, { useState } from "react";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import { smallShadow } from "theme/GlobalElements";
import { useForm } from "react-hook-form";
import { colors } from "theme/Theme";
import { CheckboxContainer } from "./DeliveryMethod";
import { isMobile, isTablet } from "react-device-detect";

interface PersonalInfoProps {
  register: any;
  errors: any;
}

const PersonalInfo: React.FC<PersonalInfoProps> = ({ register, errors }) => {
  const [showCompany, setShowCompany] = useState(false);

  return (
    <PersonalInfoContainer>
      <span className="text-body form-title">Информация за доставка</span>
      <InputsContainer>
        {inputFields
          .sort((a, b) => {
            return isMobile || isTablet
              ? a.mobileOrder - b.mobileOrder
              : a.order - b.order;
          })
          .map((input, idx) => {
            return (
              <InputWrapper key={idx}>
                <ErrorMessage className="text-xs">
                  {errors && errors[input.name] && errors[input.name]?.message}
                </ErrorMessage>
                <InputField
                  type={input.type ?? ""}
                  name={input.name}
                  placeholder={input.placeholder}
                  ref={register(input.rules)}
                />
              </InputWrapper>
            );
          })}
      </InputsContainer>
      <span className="text-body form-title">Фактура</span>

      <CheckboxContainer className="options">
        <label>
          <input
            type="radio"
            name="company"
            checked={showCompany}
            onClick={() => setShowCompany(!showCompany)}
            value="Желая да ми бъде издадена фактура"
          />
          <span className="design"></span>
          <span className="text text-xs">
            Желая да ми бъде издадена фактура
          </span>
        </label>
      </CheckboxContainer>
      {showCompany && (
        <InputsContainer className="text-xs">
          <InputWrapper>
            <ErrorMessage className="text-xs">
              {errors?.name?.message}
            </ErrorMessage>
            <InputField
              placeholder="Име на фирмата"
              name="companyInvoice"
              ref={register({
                required: { value: true, message: "Полето е задължително" },
                minLength: {
                  value: 2,
                  message: "Минималната дължина е 2 символа",
                },
              })}
            />
          </InputWrapper>
          <InputWrapper>
            <ErrorMessage className="text-xs">
              {errors?.name?.message}
            </ErrorMessage>
            <InputField
              placeholder="МОЛ"
              name="molInvoice"
              ref={register({
                required: { value: true, message: "Полето е задължително" },
                minLength: {
                  value: 2,
                  message: "Минималната дължина е 2 символа",
                },
              })}
            />
          </InputWrapper>

          <InputWrapper>
            <ErrorMessage className="text-xs">
              {errors?.name?.message}
            </ErrorMessage>
            <InputField
              placeholder="ЕИК"
              name="eikInvoice"
              ref={register({
                required: { value: true, message: "Полето е задължително" },
                minLength: {
                  value: 2,
                  message: "Минималната дължина е 2 символа",
                },
              })}
            />
          </InputWrapper>
          <InputWrapper>
            <ErrorMessage className="text-xs">
              {errors?.name?.message}
            </ErrorMessage>
            <InputField
              placeholder="ДДС номер"
              name="ddsInvoice"
              ref={register({
                required: { value: true, message: "Полето е задължително" },
                minLength: {
                  value: 2,
                  message: "Минималната дължина е 2 символа",
                },
              })}
            />
          </InputWrapper>
          <InputWrapper>
            <ErrorMessage className="text-xs">
              {errors?.name?.message}
            </ErrorMessage>
            <InputField
              placeholder="Адрес на фирмата"
              name="addressInvoice"
              ref={register({
                required: { value: true, message: "Полето е задължително" },
                minLength: {
                  value: 2,
                  message: "Минималната дължина е 2 символа",
                },
              })}
            />
          </InputWrapper>
        </InputsContainer>
      )}
    </PersonalInfoContainer>
  );
};

const inputFields = [
  {
    name: "firstName",
    placeholder: "Име",
    rules: {
      required: true,
      minLength: { value: 2, message: "Минималната дължина е 2 символа" },
    },
    order: 1,
    mobileOrder: 1,
  },
  {
    name: "city",
    placeholder: "Град",
    rules: {
      required: true,
      minLength: { value: 2, message: "Минималната дължина е 2 символа" },
    },
    order: 2,
    mobileOrder: 3,
  },
  {
    name: "lastName",
    placeholder: "Фамилия",
    rules: {
      required: true,
      minLength: { value: 2, message: "Минималната дължина е 2 символа" },
    },
    order: 3,
    mobileOrder: 2,
  },
  {
    name: "address",
    placeholder: "Адрес",
    rules: {
      required: true,
      minLength: { value: 2, message: "Минималната дължина е 2 символа" },
    },
    order: 4,
    mobileOrder: 4,
  },
  {
    name: "email",
    placeholder: "Имейл адрес",
    rules: {
      required: { value: true, message: "Полето е задължително" },
      minLength: {
        value: 5,
        message: "Минималната дължина е 5 символа",
      },
      pattern: {
        value:
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
        message: "Модела на имейл е username@email.bg",
      },
    },
    order: 4,
    mobileOrder: 5,
  },
  {
    type: "number",
    name: "postCode",
    placeholder: "Пощенски код",
    rules: {
      required: { value: true, message: "Полето е задължително" },
      minLength: {
        value: 2,
        message: "Минималната дължина е 2 символа",
      },
    },
    order: 5,
    mobileOrder: 6,
  },
  {
    type: "tel",
    name: "phone",
    placeholder: "Телефон",
    rules: {
      required: { value: true, message: "Полето е задължително" },
      minLength: {
        value: 5,
        message: "Минималната дължина е 5 символа",
      },
      maxLength: {
        value: 20,
        message: "Максималната дължина е 20 символа",
      },
    },
    order: 5,
    mobileOrder: 7,
  },
];

const PersonalInfoContainer = styled.div`
  ${smallShadow}
  padding: 20px;
  margin-bottom: 20px;
  flex: 1 100%;

  h4 {
    color: black;
  }

  @media only screen and (${device.desktop}) {
    flex: 8;
    margin-bottom: 0;
    margin-right: 20px;
  }
`;

const InputsContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  margin: 20px 0;
  padding-bottom: 10px;

  @media only screen and (${device.laptop}) {
    /* justify-content: space-between; */
  }
`;

const InputField = styled.input`
  padding: 10px;
  border-radius: 5px;
  border: 1px solid ${colors.gray};
  font-size: 16px;
`;

const InputWrapper = styled.div`
  flex-basis: 100%;
  display: flex;
  flex-flow: column;
  justify-content: flex-start;

  & + & {
    margin-top: 12px;
  }

  @media only screen and (${device.laptop}) {
    &:nth-child(1),
    &:nth-child(2) {
      margin-top: 0;
    }

    &:nth-child(odd) {
      margin-right: 2%;
    }

    flex-basis: 45%;
  }
`;
const ErrorMessage = styled.div`
  height: 15px;
  color: ${colors.red};
  padding: 3px 0;
`;

export default PersonalInfo;
